import { FaqSection as FaqSectionProps } from '@cinch-nx/data-storyblok'
import { FaqAccordion } from '../../../faq-accordion/faq-accordion'

export const FaqSection = (props: FaqSectionProps) => (
  <FaqAccordion {...props} />
)
